import { SxProps, TablePagination } from "@mui/material";
import { useTranslation } from "react-i18next";
import { DEFAULT_ROWS_PER_PAGE_OPTIONS } from "src/helpers/usePagination";
import { colorBorder, colorTextMuted } from "src/design/tokens";

interface TablePaginationBarProps {
  /** Total number of rows across every page. */
  count: number;
  page: number;
  rowsPerPage: number;
  onPageChange: (page: number) => void;
  onRowsPerPageChange: (rowsPerPage: number) => void;
  rowsPerPageOptions?: number[];
  sx?: SxProps;
}

/** Pagination footer for the tables rendered inside an `InfoCard`. */
export const TablePaginationBar = ({
  count,
  page,
  rowsPerPage,
  onPageChange,
  onRowsPerPageChange,
  rowsPerPageOptions = DEFAULT_ROWS_PER_PAGE_OPTIONS,
  sx,
}: TablePaginationBarProps) => {
  const { t } = useTranslation();

  return (
    <TablePagination
      component="div"
      count={count}
      page={page}
      rowsPerPage={rowsPerPage}
      rowsPerPageOptions={rowsPerPageOptions}
      onPageChange={(_event, value) => onPageChange(value)}
      onRowsPerPageChange={(event) =>
        onRowsPerPageChange(Number(event.target.value))
      }
      labelRowsPerPage={t("common.pagination.rowsPerPage")}
      labelDisplayedRows={({ from, to, count: total }) =>
        t("common.pagination.displayedRows", { from, to, total })
      }
      sx={{
        borderTop: `1px solid ${colorBorder}`,
        color: colorTextMuted,
        "& .MuiTablePagination-selectLabel, & .MuiTablePagination-displayedRows":
          { fontSize: 13, margin: 0 },
        ...sx,
      }}
    />
  );
};
